import { Meeting } from '../files.page';

const ORDER_KEYS: Record<string, string> = {
  files: 'aivox_meetings_order',
  favorites: 'aivox_favorites_order',
};

export function loadMeetingsOrder(type: 'files' | 'favorites' | 'trash'): string[] {
  if (type === 'trash') return [];
  try {
    const raw = localStorage.getItem(ORDER_KEYS[type] || ORDER_KEYS.files);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function saveMeetingsOrder(type: 'files' | 'favorites' | 'trash', order: string[]): void {
  if (type === 'trash') return;
  const key = ORDER_KEYS[type] || ORDER_KEYS.files;
  localStorage.setItem(key, JSON.stringify(order));
}

export function applyManualOrder(items: Meeting[], order: string[]): Meeting[] {
  if (!order.length) return items;
  const byId = new Map(items.map(item => [item.id, item]));
  const seen = new Set<string>();
  const ordered: Meeting[] = [];

  for (const id of order) {
    const item = byId.get(id);
    if (item) {
      ordered.push(item);
      seen.add(id);
    }
  }

  for (const item of items) {
    if (!seen.has(item.id)) ordered.push(item);
  }

  return ordered;
}

export function reorderMeetingIds(order: string[], fromIndex: number, toIndex: number): string[] {
  const next = [...order];
  const [removed] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, removed);
  return next;
}
